import { method } from "lodash"

function imageUrl(url) {
  if (!url.startsWith("http")) {
    const imageHost = process.env.NODE_ENV == "development" ? "https://lafia-studio.com" : ""
    return imageHost + url
  }
  return url
}

function profileImageUrl(url) {
  if (!url.startsWith("http")) {
    return imageUrl("/upload/user/profile_image/" + url)
  }
  return url
}

export default {
  imageUrl,
  profileImageUrl,
}
